module.exports = __webpack_public_path__ + "static/sunset_in_oia_seen_from_imerovigli-982f58059d39d288a72267c75b6eaf55.mp4";